import React from 'react';
import { Phone } from 'lucide-react';

const SevenDaysTanzania = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white text-[#2f4f2f] py-4 px-6 border-b border-[#9acd32]/20">
        <h1 className="text-2xl font-bold">7 Days Tanzania Luxury Safari</h1>
      </header>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <h2 className="text-3xl font-bold text-[#2f4f2f] mb-6">
          7 Days Tanzania Luxury Safari - Tarangire, Lake Manyara, Serengeti & Ngorongoro Crater
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* Main Content - Left Side */}
          <div className="md:col-span-8">
            {/* Description */}
            <div className="mb-8">
              <p className="text-gray-700 leading-relaxed mb-4">
                Discover the <strong>enchanting allure of Tanzania</strong>, a land of stunning natural beauty, abundant wildlife, and unforgettable adventures, all 
                made even more special by the warmth of its people. This <strong>7 days Tanzania luxury safari package</strong> takes you on a stylish journey 
                through the Northern Safari Circuit where you can stay in top notch lodges and tented camps, enjoying exceptional food and 
                service. Experience the diverse landscapes and immerse yourself in the rich wildlife of these destinations! the Engage Northern 
                circuit with our professional driver guides.
              </p>
            </div>

            {/* Placeholder for Safari Image */}
            <div className="mb-8">
              <div className="bg-[#f5f5f5] h-64 rounded-lg flex items-center justify-center text-gray-500 text-sm">
                
                <img src="/cheta.JPG" alt="5 Days Best of Tanzania Safari" className="w-full h-48 object-cover"/>
              </div>
              <p className="text-sm text-gray-600 mt-2 italic">Cheetahs in the Serengeti National Park</p>
            </div>

            {/* Itinerary Section */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#2f4f2f] mb-6">Itinerary for the 7 Days Tanzania Luxury Safari</h3>

              {/* Day 1 */}
              <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
                <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 1: Arrival in Arusha</h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Upon your arrival at the airport, our safari driver guide will greet you and drive you to your accommodation in Arusha. Depending on 
                  your arrival time, you might have the opportunity to unwind and get ready for the incredible journey the following day.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Arusha, bustling and vibrant, is a key hub for safari expeditions in northern Tanzania, and almost all travellers find themselves here 
                  at some point in their adventure.
                </p>
                <p className="font-semibold text-[#2f4f2f]">Accommodation: Gran Melia</p>
              </div>

              {/* Day 2 */}
              <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
                <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 2: Transfer to Tarangire National Park</h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  After breakfast, your Safari driver guide will pick you up from your accommodation to begin your journey to Tarangire National Park. 
                  Here you will experience the true essence of what a safari and adventure in Tanzania will offer you with 2 full hours on smooth tarmac 
                  roads, offering a preview of the wild beauty to come.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Tarangire National Park is renowned for its thriving wildlife, especially the impressive elephant herds that roam the park. During the 
                  dry season, you might witness these majestic creatures gathering at the river to drink or cool off. The park is also a haven for bird 
                  enthusiasts, boasting over 400 bird species.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  The landscape, adorned with towering baobab trees, is breathtaking. These ancient trees, essential to the ecosystem, provide 
                  shelter for bees, birds, and bats, offer nourishing fruit, and serve as a vital water source during the dry season.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  You will enjoy lunch at a scenic spot within the park, followed by a game drive. Afterward, you will be transported to your 
                  accommodation near the park for a restful evening.
                </p>
                <p className="font-semibold text-[#2f4f2f]">Accommodation: Silalei Lodge</p>
              </div>

              {/* Day 3 */}
              <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
                <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 3: Lake Manyara National Park</h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Following breakfast, you will set off for Lake Manyara National Park, a compact yet richly packed reserve. This park provides a 
                  unique wilderness experience, encompassing a range of habitats from the Rift Valley soda lake to dense woodlands and rugged 
                  cliffs.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Beyond its stunning scenery, Lake Manyara is renowned for its rare tree-climbing lions and the elephant herds it was created to 
                  protect. The lake's shores are a birdwatcher's paradise, attracting around 400 bird species, including many waterfowl, and 
                  flamingos when the conditions are perfect. Large flocks of baboons, elephants, wildebeest, zebras, giraffes, and impala also live 
                  throughout within the confines and in...
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  After a day of exploration in the park, you will take a short drive to your luxury accommodation in Karatu for a relaxing evening.
                </p>
                <p className="font-semibold text-[#2f4f2f]">Accommodation: Hotel Lodge</p>
              </div>

              {/* Day 4 */}
              <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
                <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 4: Serengeti National Park</h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  After breakfast, you will head to the cooler highlands of the Ngorongoro Conservation Area. Along the way you will have the 
                  opportunity to stop and admire the breathtaking views of the Ngorongoro Crater. Continuing with your journey you will travel 
                  through the spectacular park before reaching the Serengeti in the afternoon.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  The Serengeti is a marvel, renowned for its expansive grasslands that offer incredible wildlife viewing. While it is home to a diverse 
                  array of animals, it is most famous for the Great Migration. Each year, immense herds of wildebeest, zebra, and antelope move 
                  through the plains in search of fresh grazing grounds. No matter the month, the migration can be observed if you know where to find it.
                </p>
                <p className="font-semibold text-[#2f4f2f]">Accommodation: Nyota Luxury Camp</p>
              </div>

              {/* Day 5 */}
              <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
                <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 5: Full Day Game Drive in Serengeti National Park</h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  You will spend the entire day exploring the Serengeti, one of the world's most renowned reserve parks. Known for its endless 
                  grasslands, the Serengeti offers unparalleled opportunities to witness the rich wildlife. Be one of the oldest ecosystems on the 
                  planet, its essential features of climate, vegetation and fauna have barely changed in the past million years.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  This park is home to an incredible diversity of animals, providing the best chances to see predators like lions, cheetahs, and 
                  leopards, alongside a multitude of other species.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  You have the option to embark on early morning and late afternoon game drives, returning to camp for lunch, or enjoy a full day 
                  game drive with a picnic lunch in the park.
                </p>
                <p className="font-semibold text-[#2f4f2f]">Accommodation: Nyota Luxury Camp</p>
              </div>

              {/* Day 6 */}
              <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
                <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 6: Serengeti to Ngorongoro Crater</h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  After breakfast, you will journey from Serengeti National Park to the Ngorongoro Crater. This remarkable crater, originally a 
                  massive volcano, is now the largest intact caldera in the world. It's said that before it erupted, it was once Africa's highest peak! Now, this ancient caldera is a stunning wildlife sanctuary.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Descending into the crater is an exciting experience and once on the crater floor, you will encounter vast herds of wildebeest, zebra, 
                  gazelle, and over 500 bird species. The crater is also one of the best places in Africa to spot the endangered black rhino, often seen 
                  roaming the open grasslands.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  After spending the afternoon exploring the crater, you will head to your accommodation in Karatu for dinner and an overnight stay.
                </p>
                <p className="font-semibold text-[#2f4f2f]">Accommodation: Melia Lodge</p>
              </div>

              {/* Day 7 */}
              <div className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
                <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">Day 7: Karatu to the Airport</h4>
                <p className="text-gray-700 leading-relaxed mb-4">
                  You will be transferred back to Arusha. Departure times will be adjusted according to your onward travel arrangements. We trust 
                  that you carry safari experiences and all African Adventure Travellers will be thoroughly memorable!
                </p>
              </div>
            </div>

            {/* Inclusions Section */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#2f4f2f] mb-4">Inclusions</h3>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li className="flex items-start">
                  <span className="text-[#9acd32] mr-2">•</span>
                  Accommodation based on a safari vehicle with a pop-up roof
                </li>
                <li className="flex items-start">
                  <span className="text-[#9acd32] mr-2">•</span>
                  Accommodations and meals as stated
                </li>
                <li className="flex items-start">
                  <span className="text-[#9acd32] mr-2">•</span>
                  Entrance fees to all National Parks
                </li>
                <li className="flex items-start">
                  <span className="text-[#9acd32] mr-2">•</span>
                  En route lunches
                </li>
                <li className="flex items-start">
                  <span className="text-[#9acd32] mr-2">•</span>
                  Bottled water
                </li>
                <li className="flex items-start">
                  <span className="text-[#9acd32] mr-2">•</span>
                  Service of a professional English-speaking driver guide
                </li>
                <li className="flex items-start">
                  <span className="text-[#9acd32] mr-2">•</span>
                  English Driver guide
                </li>
              </ul>
            </div>

            {/* Exclusions Section */}
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-[#2f4f2f] mb-4">Exclusions</h3>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li className="flex items-start">
                  <span className="text-[#228b22] mr-2">•</span>
                  International flights
                </li>
                <li className="flex items-start">
                  <span className="text-[#228b22] mr-2">•</span>
                  Optional activities
                </li>
                <li className="flex items-start">
                  <span className="text-[#228b22] mr-2">•</span>
                  Tips for guides
                </li>
                <li className="flex items-start">
                  <span className="text-[#228b22] mr-2">•</span>
                  Laundry
                </li>
                <li className="flex items-start">
                  <span className="text-[#228b22] mr-2">•</span>
                  Alcoholic drinks
                </li>
                <li className="flex items-start">
                  <span className="text-[#228b22] mr-2">•</span>
                  Meals, snacks and vaccinations & tests
                </li>
                <li className="flex items-start">
                  <span className="text-[#228b22] mr-2">•</span>
                  Health test requirements
                </li>
                <li className="flex items-start">
                  <span className="text-[#228b22] mr-2">•</span>
                  Personal travel Insurance
                </li>
                <li className="flex items-start">
                  <span className="text-[#228b22] mr-2">•</span>
                  Items of personal nature
                </li>
              </ul>
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="md:col-span-4">
            <div className="sticky top-6">
              {/* Safari Details Card */}
              <div className="bg-white border border-[#9acd32]/20 rounded-lg p-6 mb-6">
                <div className="space-y-3">
                  <div>
                    <span className="block text-lg font-bold text-[#2f4f2f]">7 Days Tanzania Luxury</span>
                  </div>
                  <div>
                    <span className="block text-sm font-medium text-gray-600">Duration</span>
                    <span className="block text-sm text-gray-700">7 Days 6 Nights safari</span>
                  </div>
                  <div>
                    <span className="block text-sm font-medium text-gray-600">Location</span>
                    <span className="block text-sm text-gray-700">Tanzania</span>
                  </div>
                  <div>
                    <span className="block text-sm font-medium text-gray-600">Departure / Return</span>
                    <span className="block text-sm text-gray-700">Arusha - Your final departure to your hotel</span>
                  </div>
                </div>
              </div>

              {/* Booking Button */}
              <button className="w-full bg-[#2f4f2f] hover:bg-[#228b22] text-white font-semibold py-3 px-4 rounded-lg mb-6 transition-colors">
                Plan Your Trip Now
              </button>

              {/* Contact Information */}
              <div className="text-center bg-white border border-[#9acd32]/20 rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-2">Call/WhatsApp for a Free Quote</p>
                <p className="text-lg font-bold text-[#2f4f2f]">
                  <Phone className="inline mr-2" size={20} />
                  <a href="tel:+255753182737" className="text-[#9acd32] hover:text-[#228b22] transition-colors">+255 753 182 737</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SevenDaysTanzania;